/**
 * Bevindingen, in de termen van `docs/woordenlijst.md` en de API.
 *
 * - **Gebrek** (`defect`) en **aandachtspunt** (`attention`) zijn de twee soorten;
 *   een schoon antwoord (`clean`) is geen bevinding.
 * - Kosten staan in drie kolommen: **Direct**, **Op termijn** en **Verbetering**.
 */
export const FINDING_SEVERITIES = ['clean', 'attention', 'defect'] as const;

export type FindingSeverity = (typeof FINDING_SEVERITIES)[number];

/** De twee soorten die een inspecteur zelf kan kiezen. */
export const MANUAL_SEVERITIES = [
    'defect',
    'attention',
] as const satisfies readonly FindingSeverity[];

export type ManualSeverity = (typeof MANUAL_SEVERITIES)[number];

export const FINDING_SEVERITY_LABELS: Record<ManualSeverity, string> = {
    defect: 'Gebrek',
    attention: 'Aandachtspunt',
};

export const URGENCIES = ['direct', 'term', 'improvement'] as const;

export type Urgency = (typeof URGENCIES)[number];

export const URGENCY_LABELS: Record<Urgency, string> = {
    direct: 'Direct',
    term: 'Op termijn',
    improvement: 'Verbetering',
};

export function isUrgency(value: string | null | undefined): value is Urgency {
    return (
        value !== null && value !== undefined && (URGENCIES as readonly string[]).includes(value)
    );
}

export function isManualSeverity(value: string | null | undefined): value is ManualSeverity {
    return (
        value !== null &&
        value !== undefined &&
        (MANUAL_SEVERITIES as readonly string[]).includes(value)
    );
}

/** Bijlage-classificatie voor NHG. */
export const NHG_CLASSIFICATIONS = ['vijfjaar', 'direct', 'niet'] as const;

export type NhgClassification = (typeof NHG_CLASSIFICATIONS)[number];

export const NHG_CLASSIFICATION_LABELS: Record<NhgClassification, string> = {
    vijfjaar: 'Naar verwachting 5 jaar',
    direct: 'Direct noodzakelijk',
    niet: 'Niet opnemen',
};

export function isNhgClassification(value: string | null | undefined): value is NhgClassification {
    return (
        value !== null &&
        value !== undefined &&
        (NHG_CLASSIFICATIONS as readonly string[]).includes(value)
    );
}
